import _ from 'lodash';
import html2pdf from 'html2pdf.js';
// import { Tooltip } from '@trendmicro/react-tooltip';
import {
  SALES_CATALYST_REDUCERS_AUDIENCE,
  SALES_CATALYST_REDUCERS_SUB_AUDIENCE,
  SALES_CATALYST_REDUCERS_COMPETITORS,
  SALES_CATALYST_REDUCERS_MARKET,
  SALES_CATALYST_MAX_AUDIENCE,
  SALES_CATALYST_MAX_SUB_AUDIENCE,
  SALES_CATALYST_MAX_COMPETITORS,
  SALES_CATALYST_MAX_MARKET,
  SALES_CATALYST_DATA_TARGET_MARKET,
  SALES_CATALYST_DATA_ENTITY,
  SALES_CATALYST_DATA_COMPETITOR,
  SALES_CATALYST_DATA_CATEGORY,
  SALES_CATALYST_DATA_BRAND,
  COLOR_CODES_FOR_SALESCATALYST,
  SALES_CATALYST_TARGET_MARKET,
  SALES_CATALYST_MEDIA_PACKAGE,
  SALES_CATALYST_COMPETITION,
  SC_TARGET_ENTITY_REPORT,
  SC_TARGET_ENTITY_BRAND_REPORT,
  SC_TARGET_REPORT,
  SC_TARGET_BRAND_REPORT,
  SC_SUB_ENTITY_REPORT,
  SC_BRAND_REPORT,
  SC_CHART_CONFIG,
  SALES_CATALYST_DATA_SUBENTITIES,
  SALES_CATALYST_MAX_SUBENTITIES,
  SALES_CATALYST_MAX_TARGETMARKET,
  SALES_CATALYST_MAX_ENTITY,
  SALES_CATALYST_RESET_ALL,
  SC_COMPETITORS_ACTIVITIES,
  COMPETITION_DEFAULT_BACKGROUND_COLOR,
  COMPETITION_DEFAULT_TEXT_COLOR,
  COMPETITION_TEXT_COLOR,
  COMPETITION_AFTER_RUN_TEXT_COLOR,
  SC_COMPETITORS,
  SC_COMPARE_CHART_COLORS,
  SC_COMPETITORS_COMPARISON,
  COPMPARISON_TABLE_EXPAND_GRAPH_LENGTH,
  COPMPARISON_TABLE_GRAPH_LENGTH,
  STRENGTHS,
  PREFERENCE_SALES_CATALYST_BASE,
  PREFERENCE_STUDY,
  SALES_CATALYST_PREFERENCE_KEY_MAPPING,
  PREFERENCE_SALES_CATALYST_SELECTED_SE_LIST,
  PREFERENCE_SALES_CATALYST,
  PREFERENCE_SALES_CATALYST_REACH,
  PREFERENCE_SALES_CATALYST_SAMPLE,
  PREFERENCE_SALES_CATALYST_INDEX,
  PREFERENCE_SALES_CATALYST_STRENGTH_REACH,
  PREFERENCE_SALES_CATALYST_STRENGTH_INDEX,
  PREFERENCE_SALES_CATALYST_STRENGTH_SAMPLE_MINIMUM,
  PREFERENCE_SALES_CATALYST_WEAKNESSES_REACH,
  PREFERENCE_SALES_CATALYST_WEAKNESS_INDEX,
  PREFERENCE_SALES_CATALYST_WEAKNESS_SAMPLE_MINIMUM,
  STRENGTHS_FILTER_CONFIG,
  WEAKNESS_FILTER_CONFIG,
  DEFAULT_REACH,
  DEFAULT_SAMPLE,
  DEFAULT_INDEX,
  SALES_CATALYST_FEATUREID,
  PREFERENCE_SALES_CATALYST_MEDIA_FILTER_LIST,
  PREFERENCE_SALES_CATALYST_BRAND_FILTER_LIST
} from '../constants';
import { numberWithCommas, getStudyFromStudies, filterStudyList } from './CommonUtils';
import { calculateAsterisk, calculateMRIAsterisk } from './Insight360Utils';
import { setPreferenceFlag } from '../actions/preferencesActions';
import {
  resetSalesCatalystScreen,
  setSalesCatalystPreferenceData,
  setSalesCatalystPreferenceStudy,
} from '../actions/salesCatalystActions';

export const availableToAddSelection = data => {
  let isAvailableToAdd = false;
  if (data && data[SALES_CATALYST_REDUCERS_AUDIENCE] !== undefined &&
    data[SALES_CATALYST_REDUCERS_AUDIENCE].length < SALES_CATALYST_MAX_AUDIENCE) {
    isAvailableToAdd = true;
  }
  if (data && data[SALES_CATALYST_REDUCERS_SUB_AUDIENCE] !== undefined &&
    data[SALES_CATALYST_REDUCERS_SUB_AUDIENCE].length < SALES_CATALYST_MAX_SUB_AUDIENCE) {
    isAvailableToAdd = true;
  }
  if (data && data[SALES_CATALYST_REDUCERS_COMPETITORS] !== undefined &&
    data[SALES_CATALYST_REDUCERS_COMPETITORS].length < SALES_CATALYST_MAX_COMPETITORS) {
    isAvailableToAdd = true;
  }
  if (data && data[SALES_CATALYST_REDUCERS_MARKET] !== undefined &&
    data[SALES_CATALYST_REDUCERS_MARKET].length < SALES_CATALYST_MAX_MARKET) {
    isAvailableToAdd = true;
  }
  return isAvailableToAdd;
};

export const isDataPresentInSection = data => {
  if (data && data[SALES_CATALYST_REDUCERS_AUDIENCE] !== undefined &&
    data[SALES_CATALYST_REDUCERS_AUDIENCE].length > 0) {
    return true;
  }
  if (data && data[SALES_CATALYST_REDUCERS_SUB_AUDIENCE] !== undefined &&
    data[SALES_CATALYST_REDUCERS_SUB_AUDIENCE].length > 0) {
    return true;
  }
  if (data && data[SALES_CATALYST_REDUCERS_COMPETITORS] !== undefined &&
    data[SALES_CATALYST_REDUCERS_COMPETITORS].length > 0) {
    return true;
  }
  if (data && data[SALES_CATALYST_REDUCERS_MARKET] !== undefined &&
    data[SALES_CATALYST_REDUCERS_MARKET].length > 0) {
    return true;
  }
  return false;
};


export const availableToReset = (base, brand, pitch) => {
  return base !== undefined || isDataPresentInSection(brand) || isDataPresentInSection(pitch);
};

export const availableToAddSpecificSelection = (data, type, runEventCall = false) => {
  if (type === SALES_CATALYST_REDUCERS_AUDIENCE && data &&
    data[SALES_CATALYST_REDUCERS_AUDIENCE] !== undefined &&
    data[SALES_CATALYST_REDUCERS_AUDIENCE].length < SALES_CATALYST_MAX_AUDIENCE) {
    return true;
  }
  if (type === SALES_CATALYST_REDUCERS_SUB_AUDIENCE && data &&
    data[SALES_CATALYST_REDUCERS_SUB_AUDIENCE] !== undefined &&
    data[SALES_CATALYST_REDUCERS_SUB_AUDIENCE].length < SALES_CATALYST_MAX_SUB_AUDIENCE) {
    return true;
  }
  if (type === SALES_CATALYST_REDUCERS_COMPETITORS && data &&
    data[SALES_CATALYST_REDUCERS_COMPETITORS] !== undefined &&
    data[SALES_CATALYST_REDUCERS_COMPETITORS].length < SALES_CATALYST_MAX_COMPETITORS) {
    return true;
  }
  if (type === SALES_CATALYST_REDUCERS_MARKET && data &&
    data[SALES_CATALYST_REDUCERS_MARKET] !== undefined &&
    data[SALES_CATALYST_REDUCERS_MARKET].length < SALES_CATALYST_MAX_MARKET) {
    return true;
  }
  if ((type === SALES_CATALYST_DATA_TARGET_MARKET ||
    type === SALES_CATALYST_DATA_ENTITY ||
    type === SALES_CATALYST_DATA_CATEGORY ||
    type === SALES_CATALYST_DATA_BRAND) && data &&
    data[_.camelCase(type)] !== undefined &&
    _.isEmpty(data[_.camelCase(type)])) {
    return true;
  }
  if (type === SALES_CATALYST_DATA_SUBENTITIES && data &&
    data[_.camelCase(type)] !== undefined &&
    data[_.camelCase(type)].length < SALES_CATALYST_MAX_SUBENTITIES) {
    return true;
  }
  if (type === SALES_CATALYST_DATA_COMPETITOR && data &&
    data[_.camelCase(type)] !== undefined && !runEventCall &&
    data[_.camelCase(type)].length < SALES_CATALYST_MAX_COMPETITORS) {
    return true;
  }
  // Enabling Run Button For Competitiors Screen
  if (type === SALES_CATALYST_DATA_COMPETITOR && data &&
    data[_.camelCase(type)] !== undefined && runEventCall &&
    data[_.camelCase(type)].length < 1) {
    return true;
  }
  return false;
};

export const createExpressionList = (
  targetMarket,
  entity,
  competitors,
  brand
) => {
  /**
   *  Expression List index order
   *  0 - targetMarket
   *  1 - entity
   *  2 - competitor1
   *  3 - competitor2
   *  4 - competitor3
   *  5 - brand
   *  6 - base
   * */
  const expressionList = [];
  const labels = [];
  if (targetMarket.length === 0) {
    expressionList.push('');
    labels.push('');
  } else {
    expressionList.push(targetMarket[0].expression);
    labels.push(targetMarket[0].label);
  }
  if (entity.length === 0) {
    expressionList.push('');
    labels.push('');
  } else {
    expressionList.push(entity[0].expression);
    labels.push(entity[0].label);
  }
  if (competitors.length === 0) {
    for (let i = 0; i < SALES_CATALYST_MAX_COMPETITORS; i+=1) {
      expressionList.push('');
      labels.push('');
    }
  } else {
    const len = competitors.length;
    if (len === SALES_CATALYST_MAX_COMPETITORS) {
      competitors.forEach(item => {
        expressionList.push(item.expression);
        labels.push(item.label);
      });
    } else {
      competitors.forEach(item => {
        expressionList.push(item.expression);
        labels.push(item.label);
      });
      for (let i = 0; i < SALES_CATALYST_MAX_COMPETITORS - len; i+=1) {
        expressionList.push('');
        labels.push('');
      }
    }
  }
  if (brand.length === 0) {
    expressionList.push('');
    labels.push('');
  } else {
    expressionList.push(brand[0].expression);
    labels.push(brand[0].label);
  }
  /*
  base now is sent as its own base expression
  if (base === undefined) {
    expressionList.push('');
    labels.push('');
  } else {
    expressionList.push(base.expression);
    labels.push(base.label);
  } */
  return { expressionList, labels };
};

export const getDataSelectionData = (list, dataSelection, salesCatalystBase, isBaseSampleValid) => {
  let targetMarket = [];
  let entity = [];
  let competitor = [];
  let brand = [];
  const targetEntityOverlap = {};
  const subEntities = [];
  const deletedExpressionsList = [];
  if (dataSelection.targetMarket.length !== 0) {
    const index = 0; // Index zero refers to targermarket
    const targetMarketObject = _.cloneDeep(dataSelection.targetMarket);
    if (list[index] !== null && list[index].sample > 0) {
      targetMarketObject[index].sample = list[index].sample;
      targetMarketObject[index].weighted = list[index].weighted;
      targetMarketObject[index].pct = list[index].pct;
      targetMarket = targetMarketObject;
    } else {
      deletedExpressionsList.push(targetMarketObject[0]);
    }
  }
  if (dataSelection.entity.length !== 0) {
    const index = 1; // Index one refers to entity
    const entityObject = _.cloneDeep(dataSelection.entity);
    if (list[index] !== null && list[index].sample > 0) {
      entityObject[0].sample = list[index].sample;
      entityObject[0].weighted = list[index].weighted;
      entityObject[0].pct = list[index].pct;
      entity = entityObject;
    } else {
      deletedExpressionsList.push(entityObject[0]);
    }
  }
  if (dataSelection.competitor.length !== 0) {
    const index = SALES_CATALYST_MAX_TARGETMARKET + SALES_CATALYST_MAX_ENTITY;
    const competitorObject = _.cloneDeep(dataSelection.competitor);
    for (let i = 0; i < dataSelection.competitor.length; i+=1) {
      if (list[index + i] !== null && list[index + i].sample > 0) {
        competitorObject[i].sample = list[index + i].sample;
        competitorObject[i].weighted = list[index + i].weighted;
        competitorObject[i].pct = list[index + i].pct;
      } else {
        deletedExpressionsList.push(_.cloneDeep(competitorObject[i]));
        competitorObject[i] = {};
      }
    }
    const updatedObject = competitorObject.length > 0 ?
      competitorObject.filter(item => !_.isEmpty(item)) : competitorObject;
    competitor = updatedObject;
  }

  if (dataSelection.brand.length !== 0) {
    const brandObject = _.cloneDeep(dataSelection.brand);
    const index = SALES_CATALYST_MAX_TARGETMARKET +
      SALES_CATALYST_MAX_ENTITY + SALES_CATALYST_MAX_COMPETITORS;
    if (list[index] !== null && list[index].sample > 0) {
      brandObject[0].sample = list[index].sample;
      brandObject[0].weighted = list[index].weighted;
      brandObject[0].pct = list[index].pct;
      brand = brandObject;
    } else {
      deletedExpressionsList.push(brandObject[0]);
    }
  }

  if (salesCatalystBase !== undefined) {
    const salesCatalystBaseObject = _.cloneDeep(salesCatalystBase);
    if (isBaseSampleValid) {
      salesCatalystBase = salesCatalystBaseObject;
    } else {
      deletedExpressionsList.push({
        label: salesCatalystBaseObject.label,
        expression: salesCatalystBaseObject.expression,
        base: true,
      });
      salesCatalystBase = undefined;
    }
  }

  const newObject = {
    targetMarket,
    entity,
    competitor,
    category: {},
    brand,
    targetEntityOverlap,
    subEntities,
  };
  return { deletedDetails: deletedExpressionsList, dataSelection: newObject, salesCatalystBase };
};

export const createSSDataOptions = selTab => {
  let dataOptions = [];
  switch (selTab) {
    case SALES_CATALYST_TARGET_MARKET:
      dataOptions = [SALES_CATALYST_DATA_TARGET_MARKET,
        SALES_CATALYST_DATA_ENTITY];
      break;
    case SALES_CATALYST_MEDIA_PACKAGE:
      dataOptions = [SALES_CATALYST_DATA_TARGET_MARKET,
        SALES_CATALYST_DATA_ENTITY,
        SALES_CATALYST_DATA_BRAND,
        /* SALES_CATALYST_DATA_COMPETITOR,
        SALES_CATALYST_DATA_CATEGORY,
        SALES_CATALYST_DATA_BRAND */];
      break;
    case SALES_CATALYST_COMPETITION:
      dataOptions = [SALES_CATALYST_DATA_TARGET_MARKET,
        SALES_CATALYST_DATA_ENTITY,
        SALES_CATALYST_DATA_COMPETITOR];
      break;
    case SALES_CATALYST_RESET_ALL:
      dataOptions = [SALES_CATALYST_DATA_TARGET_MARKET,
        SALES_CATALYST_DATA_ENTITY,
        SALES_CATALYST_DATA_BRAND,
        SALES_CATALYST_DATA_CATEGORY,
        SALES_CATALYST_DATA_COMPETITOR,
        /* SALES_CATALYST_DATA_CATEGORY,
        SALES_CATALYST_DATA_BRAND */];
      break;
    default:
      dataOptions = [SALES_CATALYST_DATA_ENTITY,
        SALES_CATALYST_DATA_TARGET_MARKET];
  }
  return dataOptions;
};

export const getColorCodeForGivenCategory = category => {
  const colorObj = _.find(COLOR_CODES_FOR_SALESCATALYST, category);
  return colorObj !== undefined
    ? colorObj[category]
    : 'transparent';
};

export const setPerferenceColorCode = (colors, category) => {
  const colorObj = _.find(colors, { label: category });
  return colorObj !== undefined
    ? colorObj.color
    : 'transparent';
};

export const calTargetMarketGraphColor = (subCategory, dataSelection) => {
  let colorPercenatgeOfEntity = 100;
  let colorPercenatgeOfTarget = 100;
  let colorPercenatgeOfOverLap = 100;
  let color = 'transparent';
  let getColorCode = '';
  if (subCategory === 'entityTargetOverlap' && dataSelection.targetMarket.length > 0 &&
    dataSelection.entity.length > 0) {
    const tartgetweighted = _.round(_.clone(dataSelection.targetMarket[0].weighted));
    const overLapweighted = _.round(_.clone(dataSelection.targetEntityOverlap.weighted));
    colorPercenatgeOfOverLap = _.round((overLapweighted * 100) / tartgetweighted);
    if (colorPercenatgeOfOverLap > 100) {
      colorPercenatgeOfOverLap = 100;
    }
    getColorCode = getColorCodeForGivenCategory(subCategory.toUpperCase());
    const getColorCodeOftarget = getColorCodeForGivenCategory('targetMarket'.toUpperCase());
    color = `${`linear-gradient(to right,${getColorCode}0%,${getColorCode}${colorPercenatgeOfOverLap.toString()
      }%, ${getColorCodeOftarget} 0%, ${getColorCodeOftarget} 100%)`}`;
  } else {
    if (dataSelection.targetMarket.length > 0 &&
      dataSelection.entity.length > 0) {
      const tartgetweighted = _.round(_.clone(dataSelection.targetMarket[0].weighted));
      const enitytweighted = _.round(_.clone(dataSelection.entity[0].weighted));
      colorPercenatgeOfEntity = _.round((enitytweighted * 100) / tartgetweighted);
      if (colorPercenatgeOfEntity > 100) {
        colorPercenatgeOfTarget = _.round((tartgetweighted * 100) / enitytweighted);
        colorPercenatgeOfEntity = 100;
      }
    }
    if (subCategory === 'targetMarket') {
      getColorCode = getColorCodeForGivenCategory(subCategory.toUpperCase());
      color = `${`linear-gradient(to right,${getColorCode}0%,${getColorCode}${colorPercenatgeOfTarget.toString()
        }%, transparent 0%, transparent 100%)`}`;
    }
    if (subCategory === 'entity') {
      getColorCode = getColorCodeForGivenCategory(subCategory.toUpperCase());
      color = `${`linear-gradient(to right,${getColorCode}0%,${getColorCode}${colorPercenatgeOfEntity.toString()
        }%, transparent 0%, transparent 100%)`}`;
    }
  }
  return color;
};

export const dataScreenOptions = selTab => {
  let dataOptions = [];
  switch (selTab) {
    case SALES_CATALYST_TARGET_MARKET:
      dataOptions = [_.camelCase(SALES_CATALYST_TARGET_MARKET),
      _.camelCase(SALES_CATALYST_MEDIA_PACKAGE),
      _.camelCase(SALES_CATALYST_COMPETITION)];
      break;
    case SALES_CATALYST_MEDIA_PACKAGE:
      dataOptions = [_.camelCase(SALES_CATALYST_MEDIA_PACKAGE)];
      break;
    case SALES_CATALYST_COMPETITION:
      dataOptions = [_.camelCase(SALES_CATALYST_COMPETITION)];
      break;
    default:
      dataOptions = [];
  }
  return dataOptions;
};

export const calMediaPackageColor = (subCategory, dataSelection) => {
  let color = 'transparent';
  if (subCategory === 'brand') {
    const getColorCode = getColorCodeForGivenCategory(subCategory.toUpperCase());
    const brandweighted = _.round(_.clone(dataSelection.brand[0].weighted));
    const categoryweighted = _.round(_.clone(dataSelection.category.sampleWgtd.weighted));
    const colorPercenatgeOfOverLap = _.round((brandweighted * 100) / categoryweighted);
    color = `${`linear-gradient(to right,${getColorCode}0%,${getColorCode}${colorPercenatgeOfOverLap.toString()
      }%, transparent 0%, transparent 100%)`}`;
  }

  if (subCategory === 'category') {
    const getColorCode = getColorCodeForGivenCategory(subCategory.toUpperCase());
    color = `${`linear-gradient(to right,${getColorCode}0%,${getColorCode}100%, transparent 0%, transparent 100%)`}`;
  }
  return color;
};

export const resetGraphData = selTab => {
  let dataOptions = [];
  switch (selTab) {
    case 'targetMarket':
      dataOptions = [_.camelCase(SC_TARGET_ENTITY_REPORT),
      _.camelCase(SC_TARGET_ENTITY_BRAND_REPORT),
      _.camelCase(SC_TARGET_REPORT),
      _.camelCase(SC_TARGET_BRAND_REPORT),
      _.camelCase(SC_BRAND_REPORT),
      _.camelCase(SC_SUB_ENTITY_REPORT),
      _.camelCase(SC_COMPETITORS_ACTIVITIES),
      _.camelCase(SC_COMPETITORS),
      _.camelCase(SC_COMPETITORS_COMPARISON)];
      break;
    case 'entity':
      dataOptions = [_.camelCase(SC_TARGET_ENTITY_REPORT),
        _.camelCase(SC_TARGET_ENTITY_BRAND_REPORT),
        _.camelCase(SC_TARGET_REPORT),
        _.camelCase(SC_TARGET_BRAND_REPORT),
        _.camelCase(SC_BRAND_REPORT),
        _.camelCase(SC_SUB_ENTITY_REPORT),
        _.camelCase(SC_COMPETITORS_ACTIVITIES),
        _.camelCase(SC_COMPETITORS),
        _.camelCase(SC_COMPETITORS_COMPARISON)];
      break;
    case 'brand':
      dataOptions = [_.camelCase(SC_TARGET_ENTITY_BRAND_REPORT),
      _.camelCase(SC_TARGET_BRAND_REPORT)];
      break;
    case 'competitor':
      dataOptions = [_.camelCase(SC_COMPETITORS_ACTIVITIES),
        _.camelCase(SC_COMPETITORS),
        _.camelCase(SC_COMPETITORS_COMPARISON)];
      break;
    default:
      dataOptions = [];
  }
  return dataOptions;
};

export const processChartData = (data, sortInfo) => {
  let cData = data;
  const chartData = {
    label: undefined,
    groups: [],
    categories: [],
    chartFirst: [],
    chartSecond: [],
    maxVal: undefined,
  };

  if (cData === undefined || _.isEmpty(cData)) {
    return chartData;
  }

  if (!_.isEmpty(sortInfo)) {
    let dtlsIndex = cData.groups.length > 1 ? sortInfo.index : 0;
    const sortedData = _.orderBy(cData.subEntities, [e => {
      dtlsIndex = e.details[dtlsIndex] ? dtlsIndex : 0;
      if (sortInfo.sortBy === 'Index') {
        return e.details[dtlsIndex].index;
      }
      return _.toNumber(e.details[dtlsIndex].pct.replace('%', ''));
    }], [`${sortInfo.type}`]);

    cData = { ...cData, subEntities: sortedData };
  }

  chartData.label = cData.label;
  chartData.groups = cData.groups;

  _.forEach(cData.subEntities, val => {
    if (!_.find(chartData.categories, o => o.expression === val.label)) {
      chartData.categories.push({ label: val.label, expression: val.expression });
      _.forEach(val.details, (d, i) => {
        const yData = {
          y: d.index,
          indexVal: numberWithCommas(
            Math.round(d.index),
          ),
          weighted: numberWithCommas(
            Math.round(d.weighted),
          ),
          sample: numberWithCommas(
            Math.round(d.sample),
          ),
          reach: _.toNumber(d.pct.replace('%', '')),
        };
        if (i === 0) {
          if (d.index < 100) {
            yData.dataLabels = { align: chartData.groups.length === 1 ? 'right' : 'left' };
          }
          chartData.chartFirst.push(yData);
        } else {
          if (d.index < 100) {
            yData.dataLabels = { align: 'right' };
          }
          chartData.chartSecond.push(yData);
        }
      });
    }
  });
  const maxVal = _.maxBy([...chartData.chartFirst, ...chartData.chartSecond], val => val.y);
  chartData.maxVal = maxVal !== undefined ? maxVal.y : undefined;
  return chartData;
};

export const calcChartHeight = catLength => {
  const maxItems = SC_CHART_CONFIG.maxItems;
  return ((catLength >= maxItems ? catLength : maxItems)
    * (SC_CHART_CONFIG.pointWidth + SC_CHART_CONFIG.barPadding))
    + _.sum([SC_CHART_CONFIG.marginTop, SC_CHART_CONFIG.marginBottom]);
};

export const download = (pdfFileName, htmlFormat) => {
  const opt = {
    filename: pdfFileName,
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2, letterRendering: true },
    jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape', dpi: 96 },
    hotfixes: [],
  };

  html2pdf()
    .from(htmlFormat)
    .set(opt)
    .toPdf()
    .get('pdf')
    .then(() => { })
    .save();
};

export const processChartConfigData = (studyInfo, categories, seriesData, maxVal, config) => {
  const isMRISpecificStudy = studyInfo.ss.includes('MRI');
  const warningType = studyInfo.wnt;
  const pointWidth = categories.length > 10 ? SC_CHART_CONFIG.pointWidth : undefined;
  const chartMargin = [SC_CHART_CONFIG.marginTop, 0, SC_CHART_CONFIG.marginBottom, 0];
  const max = maxVal !== undefined && maxVal > 290 ? maxVal + 10 : 300;
  const configData = {
    chart: {
      type: 'bar',
      height: calcChartHeight(categories.length),
      margin: chartMargin,
    },
    title: {
      text: '',
    },
    subtitle: {
      text: '',
    },
    xAxis: {
      gridLineWidth: 0,
      tickWidth: 0,
      minorGridLineWidth: 0,
      lineColor: 'transparent',
      categories,
      title: {
        text: null,
      },
      labels: {
        enabled: false,
      },
    },
    yAxis: {
      reversed: config !== undefined && config.yAxisReversed ? config.yAxisReversed : false,
      opposite: true,
      min: 0,
      max,
      title: {
        text: '',
        align: 'high',
      },
      labels: {
        y: -3,
        formatter() {
          if (this.value !== 100) { return ''; }
          return this.value;
        },
      },
      tickWidth: 0,
      gridLineWidth: 0,
      plotLines: [{
        color: 'rgb(111, 111, 111)',
        width: 2,
        value: 100,
        zIndex: 5,
      }],
    },
    tooltip: {
      borderRadius: 15,
      borderColor: 'rgb(212, 216, 221)',
      backgroundColor: '#fff',
      style: {
        fontSize: '11px',
      },
      formatter() {
        return `SAMPLE: <b>${this.point.sample}</b>
          <br/>WEIGHTED: <b>${this.point.weighted}</b><br/>REACH: <b>${this.point.reach}%</b>`;
      },
    },
    plotOptions: {
      series: {
        pointWidth,
        states: {
          hover: {
            enabled: false,
          },
        },
      },
      bar: {
        dataLabels: {
          enabled: true,
          crop: false,
          allowOverlap: true,
          style: {
            fontWeight: 'normal',
            color: 'rgb(130, 130, 130)',
          },
          formatter() {
            const asterik = isMRISpecificStudy ?
              calculateMRIAsterisk(this.point.sample, warningType) : calculateAsterisk(this.point.sample);
            return ` ${asterik}${this.point.indexVal}`;
          },
        },
      },
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    series: [{
      name: '',
      data: seriesData,
      color: config !== undefined && config.barColor ? config.barColor : SC_CHART_CONFIG.colors[0],
    }],
  };
  return configData;
};

/* export const splitLabel = value => {
  value = value.split('(');
  if (value[0].length !== 0) {
    return value[0].trim();
  }
  return value[1].trim();
}; */
/*
const formatTitleToDisplay = title => {
  let finalTitle = '';
  let insert = true;
  title.split('').forEach(char => {
    if (char === '(') {
      insert = false;
    }
    if (insert) {
      finalTitle += char;
    }
    if (char === ')') {
      insert = true;
    }
  });
  return finalTitle;
};

export const splitLabel = value => {
  const title = _.clone(value);
  const splitTitle = title.split('AND');
  let formatedTitle = formatTitleToDisplay(splitTitle[0]);
  if (splitTitle.length > 1) {
    formatedTitle += 'AND ...';
  }
  return formatedTitle;
};
*/
export const splitLabel = value => {
  let title = _.clone(value);
  let formatedTitle;
  const skipStep = title.indexOf(' ...');
  if (skipStep !== -1) {
    return title;
  }
  const firstChar = title.charAt(0);
  const lastChar = title.charAt(title.length - 1);

  if (firstChar === '(' && lastChar === ')') {
    title = title.substr(1, title.length);
    title = title.slice(0, title.length - 1);
  }
  const pattIndex = title.indexOf('(');
  const findAnd = title.indexOf(' AND ');
  const findOr = title.indexOf(' OR ');
  const findXor = title.indexOf(' XOR ');
  let lowest = 0;
  let type = '';
  if (findAnd !== -1) {
    lowest = findAnd;
    type = 'AND';
  }
  if (findOr !== -1 && (lowest === 0 || lowest > findOr)) {
    lowest = findOr;
    type = 'OR';
  }
  if (findXor !== -1 && (lowest === 0 || lowest > findXor)) {
    lowest = findXor;
    type = 'XOR';
  }
  formatedTitle = title;
  if (pattIndex !== -1) {
    formatedTitle = title.substring(0, pattIndex).trim();
  }
  if (lowest > 0) {
    switch (type) {
      case 'AND':
        formatedTitle += ' AND ...';
        break;
      case 'OR':
        formatedTitle += ' OR ...';
        break;
      case 'XOR':
        formatedTitle += ' XOR ...';
        break;
      default:
        formatedTitle = '';
    }
  }
  return formatedTitle;
};

export const processBubbleChartData = (studyInfo, data, color) => {
  const isMRISpecificStudy = studyInfo.ss.includes('MRI');
  const warningType = studyInfo.wnt;
  const chartColors = SC_COMPARE_CHART_COLORS;
  _.forEach(chartColors, (value, index) => {
    value.fillColor = color[index + 1].color;
  });
  let maxYaxisVal = 0;
  let maxXaxisVal = 0;
  const seriesTempData = _.map(data.groups, (o, i) => {
    return {
      data: [],
      name: splitLabel(o),
      marker: chartColors[i],
    };
  });
  _.forEach(data.subEntities, o => {
    _.forEach(o.details, (d, index) => {
      if (d !== null) {
        const reachVal = _.toNumber(d.pct.replace('%', ''));
        if (d.index > maxYaxisVal) {
          maxYaxisVal = d.index;
        }
        if (reachVal > maxXaxisVal) {
          maxXaxisVal = reachVal;
        }
        if (seriesTempData[index]) {
          seriesTempData[index].data.push({
            x: reachVal,
            y: d.index,
            z: d.weighted,
            sample: d.sample,
            label: splitLabel(o.label),
          });
        }
      }
    });
  });
  const yAxisMax = maxYaxisVal + ((maxYaxisVal / 100) * 10);
  const xAxisMax = maxXaxisVal + ((maxXaxisVal / 100) * 10);
  const chartConfig = {
    chart: {
      type: 'bubble',
      zoomType: 'xy',
      className: 'sc-bubble-chart',
    },
    title: {
      text: 'HIGH INTEREST / PARTICIPATION',
      align: 'left',
      x: 60,
      y: 20,
      style: {
        fontSize: '11px',
      },
    },
    subtitle: {
      text: 'LOW INTEREST / PARTICIPATION',
      align: 'left',
      verticalAlign: 'bottom',
      x: 60,
      y: -50,
      style: {
        fontSize: '11px',
      },
    },
    xAxis: {
      gridLineWidth: 1,
      lineColor: '#323232',
      min: 0,
      max: xAxisMax,
      title: {
        enabled: true,
        text: 'REACH',
      },
      labels: {
        format: '{value}%',
      },
      /* plotLines: [{
        color: '#323232',
        width: 1,
        value: _.round(xAxisMax / 2),
        zIndex: 3,
      }], */
    },
    yAxis: {
      lineWidth: 1,
      lineColor: '#323232',
      startOnTick: false,
      endOnTick: false,
      min: 0,
      max: yAxisMax,
      title: {
        enabled: true,
        text: 'INDEX',
      },
      plotLines: [{
        color: '#323232',
        width: 1,
        /* value: _.round(yAxisMax / 2), */
        value: 100,
        zIndex: 3,
      }],
    },
    plotOptions: {
      series: {
        fillOpacity: 0.4,
        colorByPoint: true,
        marker: {
          lineWidth: 0,
          states: {
            hover: {
              radius: 0,
              enabled: false,
            },
          },
        },
      },
    },
    tooltip: {
      useHTML: true,
      borderRadius: 15,
      borderColor: 'rgb(212, 216, 221)',
      backgroundColor: '#fff',
      style: {
        fontSize: '11px',
        textAlign: 'right',
        fontFamily: 'inherit',
      },
      formatter() {
        return `<strong class="tt-title">${this.point.label}</strong>
          <strong class="lg-text">${numberWithCommas(Math.round(this.point.z))}</strong> WEIGHTED
          <br/>INDEX: ${numberWithCommas(Math.round(this.point.y))} <strong>|</strong>  REACH: ${this.point.x}%
          <br/>SAMPLE: ${isMRISpecificStudy ? calculateMRIAsterisk(this.point.sample, warningType) :
            calculateAsterisk(this.point.sample)}${this.point.sample}`;
      },
    },
    legend: {
      itemStyle: {
        fontWeight: 'normal',
      },
    },
    series: seriesTempData,
  };

  return chartConfig;
};

export const getBackGroundColor = (data, dataOnScreen, category, colors) => {
  let backgroundColor = '';
  if (colors !== undefined) {
    backgroundColor = (typeof (data) !== 'undefined' && dataOnScreen)
    ? setPerferenceColorCode(colors, category) : COMPETITION_DEFAULT_BACKGROUND_COLOR;
  } else {
    backgroundColor = (typeof (data) !== 'undefined' && dataOnScreen)
    ? getColorCodeForGivenCategory(category) : COMPETITION_DEFAULT_BACKGROUND_COLOR;
  }
  return backgroundColor;
};

export const getTextColor = (data, dataOnScreen) => {
  let color = COMPETITION_DEFAULT_TEXT_COLOR;
  if (typeof (data) !== 'undefined') {
    color = COMPETITION_TEXT_COLOR;
  }
  if (dataOnScreen && typeof (data) !== 'undefined') {
    color = COMPETITION_AFTER_RUN_TEXT_COLOR;
  }
  return color;
};

export const formOverlapTitle = (overlapdata, props) => {
  const data = _.clone(overlapdata);
  const { dataSelection } = _.clone(props);
  if (!_.isEmpty(dataSelection.targetEntityOverlap) && dataSelection.targetMarket.length > 0
    && dataSelection.entity.length > 0) {
    data.title = `${dataSelection.targetMarket[0].label} AND
    ${dataSelection.entity[0].label}`;
    const title = `${splitLabel(dataSelection.targetMarket[0].label)} &
    ${splitLabel(dataSelection.entity[0].label)}`;
    data.label = title;
  }
  return data;
};

export const formCategoryData = category => {
  let data = _.clone(category);
  if (!_.isEmpty(category)) {
    data = {
      label: category.categoryLabel,
      sample: category.sampleWgtd.sample,
      weighted: category.sampleWgtd.weighted,
      pct: category.sampleWgtd.pct,
    };
  }
  return data;
};


export const processCompetitionColumnChartData = (studyInfo, data, base, targetMarket, color) => {
  const isMRISpecificStudy = studyInfo.ss.includes('MRI');
  const warningType = studyInfo.wnt;
  const chartColors = _.cloneDeep(SC_COMPARE_CHART_COLORS);
  _.forEach(chartColors, (value, index) => {
    value.fillColor = 'rgba(255,255,255,0.4)';
    value.lineColor = color[index + 1].color;
  });
  const categories = [];
  const brandedWeightedData = [];
  const weigtedData = [];
  _.forEach(data.subEntities, (o, i) => {
    categories.push(splitLabel(o.label));
    weigtedData.push({
      isWeightedData: true,
      y: o.details[1].weighted,
      weighted: o.details[1].weighted,
      sampleIndex: o.details[1].index,
      sample: o.details[1].sample,
      pct: o.details[1].pct,
      label: splitLabel(o.label),
      color: chartColors[i].fillColor,
    });
    brandedWeightedData.push({
      isWeightedData: false,
      y: o.details[0].weighted,
      weighted: o.details[0].weighted,
      sampleIndex: o.details[0].index,
      sample: o.details[0].sample,
      pct: o.details[0].pct,
      label: splitLabel(o.label),
      color: chartColors[i].lineColor,
    });
  });


  const chartConfig = {

    chart: {
      type: 'column',
      className: 'sc-competitor-column-chart',
      fillOpacity: 0.3,
    },
    title: {
      text: '',
    },
    xAxis: {
      categories,
    },
    yAxis: {
      min: 0,
      title: {
        text: 'SAMPLE SIZE - WEIGHTED',
      },
    },
    tooltip: {
      useHTML: true,
      borderRadius: 15,
      borderColor: 'rgb(212, 216, 221)',
      backgroundColor: '#fff',
      style: {
        fontSize: '11px',
        textAlign: 'right',
        fontFamily: 'inherit',
      },
      formatter() {
        if (this.point.isWeightedData) {
          return `SHARE OF ${splitLabel(targetMarket)}<br/><strong class="tt-title">${this.point.label}</strong>
            <strong class="lg-text">${numberWithCommas(Math.round(this.point.y))}</strong> WEIGHTED<br/>
            INDEX: ${numberWithCommas(this.point.sampleIndex)} <strong>|</strong> REACH: ${this.point.pct}
            <br/>SAMPLE: ${isMRISpecificStudy ? calculateMRIAsterisk(this.point.sample, warningType) :
              calculateAsterisk(this.point.sample)}${this.point.sample}`;
        }
        return `SHARE OF ${base !== undefined ? splitLabel(base) : 'BASE'}<br/>
          <strong class="tt-title">${this.point.label}</strong>
          <strong class="lg-text">${numberWithCommas(Math.round(this.point.y))}</strong> WEIGHTED<br/>
          INDEX: ${numberWithCommas(this.point.sampleIndex)} <strong>|</strong> REACH: ${this.point.pct}
          <br/>SAMPLE: ${isMRISpecificStudy ? calculateMRIAsterisk(this.point.sample, warningType) :
            calculateAsterisk(this.point.sample)}${this.point.sample}`;
      },
    },
    plotOptions: {
      column: {
        grouping: false,
        shadow: false,
      },
      series: {
        fillOpacity: 0.4,
      },

    },
    series: [{
      showInLegend: false,
      data: brandedWeightedData,
      pointPadding: 0,

    }, {
      showInLegend: false,
      data: weigtedData,
      pointPadding: 0.1,
    }],
  };

  return chartConfig;
};

export const findRelatedDataOnScreen = (category, state) => {
  let onScreenCategory = '';
  let dataOnScreenStatus = false;
  const dataOnScreenPrev = _.clone(state.salesCatalyst.dataOnScreen);
  const dataOnScreenReset = _.clone(state.salesCatalyst.dataOnScreen);
  const prevGraphData = _.clone(state.salesCatalyst.graphData);
  const resetGraphData = {
    scTargetEntity: {},
    scTargetEntityBrand: {},
    scTarget: {},
    scTargetBrand: {},
    scBrands: {},
    scCompetitorsActivities: {},
    scCompetitors: {},
    scSubEntity: {},
    scCompetitorsComparison: [{}, {}, {}],
  };

  if (category === 'targetMarket' || category === 'entity') {
    onScreenCategory = 'targetMarket';
  }
  if (category === 'brand') {
    onScreenCategory = 'mediaPackage';
  }
  if (category === 'competitor') {
    onScreenCategory = 'competition';
  }
  if (onScreenCategory !== '') {
    dataOnScreenStatus = _.clone(dataOnScreenPrev[onScreenCategory]);
  }
  if (dataOnScreenStatus) {
    _.forEach(Object.keys(dataOnScreenPrev), data => {
      dataOnScreenReset[data] = false;
    });
  }
  return {
    dataOnScreenPrev,
    dataOnScreenReset,
    dataOnScreenStatus,
    prevGraphData,
    resetGraphData,
  };
};

export const getChartLegendColumnWidth = count => {
  switch (count) {
    case 3: {
      return '33%';
    }
    case 4: {
      return '25%';
    }
    default: {
      return '50%';
    }
  }
};

export const createSubCategoryArray = data => {
  return _.map(data, o => o.value);
};

export const createStrengthsWeaknessesList = (type, data) => {
  const dataSelection = data;
  if (type !== undefined) {
    const listTypeLabel = type;
    const list = [];
    if (dataSelection.entity.length > 0) {
      list.push({
        label: `${listTypeLabel} - ${splitLabel(dataSelection.entity[0].label)}`,
        value: `${listTypeLabel} - ${dataSelection.entity[0].label}`,
      });
    }
    _.each(dataSelection.competitor, o => {
      list.push({
        label: `${listTypeLabel} - ${splitLabel(o.label)}`,
        value: `${listTypeLabel} - ${o.label}`,
      });
    });
    return list;
  }
  return false;
};
// comparison table data


export const processCompetionGraphTableChartData = (graphData, graphType, expandMode) => {
  const seriesData = [];
  const categories = [];
  const graphDataCss = {};
  let pointWidth = 27;
  let labelWidth = '300';
  if (graphData.length > 0) {
    _.forEach(graphData, obj => {
      const tempObj = _.clone(obj.details[0]);
      tempObj.y = tempObj.index;
      if (_.lowerCase(graphType) === STRENGTHS) {
        tempObj.color = 'rgb(233, 155, 127)';
      } else {
        tempObj.color = 'rgb(132, 201, 204)';
      }
      if (expandMode === 'true') {
        if (seriesData.length < COPMPARISON_TABLE_EXPAND_GRAPH_LENGTH) {
          seriesData.push(tempObj);
          categories.push({ label: obj.label, expression: obj.expression });
        }
      } else if (seriesData.length < COPMPARISON_TABLE_GRAPH_LENGTH) {
          seriesData.push(tempObj);
          categories.push({ label: obj.label, expression: obj.expression });
        }
    });

    const graphDataCss = [];
    if (expandMode) {
      graphDataCss.push({
        containerId: 'expandGraphTableContainer',
        className: 'expand-mode-sc-table-Graph-chart',
      }); } else {
      graphDataCss.push({
        containerId: 'GraphTableContainer',
        className: 'sc-table-Graph-chart',
      });
    }

    if (expandMode === 'true') {
      labelWidth = '700';
      pointWidth = categories.lenpointWidthgth < 15 ? pointWidth : undefined;
    } else {
      labelWidth = '300';
      pointWidth = categories.lenpointWidthgth < 5 ? pointWidth : undefined;
    }

    const configData = {
      chart: {
        renderTo: graphDataCss[0].containerId,
        margin: 0,
        type: 'bar',
        className: graphDataCss[0].className,
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      subTitle: {},
      exporting: {},
      title: { text: '' },
      plotOptions: {
        series: {
          pointWidth,
          // pointPadding: 0,
          dataLabels: {
            enabled: true,
            inside: true,
          },
        },
        bar: {
          dataLabels: {
            align: 'left',
            marginLeft: '5',
            formatter() {
              return `<span class="tt-title">${this.point.category.label}<span><br/>`;
            },
            style: {
              color: '#3c3c3d',
              fontWeight: '600',
              width: labelWidth,
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              textOutline: false,
            },

          },
        },
      },

      xAxis: {
        tickWidth: 0,
        gridLineWidth: 0,
        categories,

      },
      yAxis: {
        tickWidth: 0,
        gridLineWidth: 0,
        allowDecimals: false,

        title: {
          text: '',
        },
        labels: {
          enabled: false,
        },
      },
      tooltip: {
        useHTML: true,
        borderRadius: 15,
        borderColor: 'rgb(212, 216, 221)',
        backgroundColor: '#fff',
        style: {
          fontSize: '11px',
          textAlign: 'right',
          fontFamily: 'inherit',
          outline: 'none',
        },
        formatter() {
          return `<strong class="tt-title">${this.point.category.label}</strong><br/>
            <strong class="lg-text">${numberWithCommas(Math.round(this.point.weighted))}
            </strong> WEIGHTED<br/>INDEX: ${numberWithCommas(Math.round(this.point.y))} 
            <strong>|</strong>  REACH: ${this.point.pct}<br/>
            SAMPLE: ${numberWithCommas(Math.round(this.point.sample))}`;
        },
      },
      series: [{
        color: '',
        data: seriesData,
      }],

    };
    return configData;
  }
};

export const checkItemAvailableInList = (list, item) => {
  const itemVal = item !== undefined ? item.value : undefined;
  return _.find(list, o =>
    o.value === itemVal) === undefined;
};


export const createActivitiesList = data => {
  const list = [];
  _.each(data, o => {
    list.push({
      label: o.templateName,
      value: o.templateName,
    });
  });
  return list;
};

export const setSalesCatalystDataOnSave = (
    preferences,
    dispatch,
    getState,
    sessionPref = false) => {
  // Logic To Update study
  const { salesCatalystStudies, salesCatalystStudy } = getState().study;
  if (salesCatalystStudies && salesCatalystStudies.length > 0) {
    const sessionConfigurationObject = _.cloneDeep(preferences);
    let getStudyObj;
    if (sessionPref) {
      getStudyObj = _.cloneDeep(salesCatalystStudy);
    } else if (preferences[PREFERENCE_STUDY] === -1) {
      getStudyObj = _.cloneDeep(salesCatalystStudies[0].sl[0]);
    } else {
      getStudyObj = getStudyFromStudies(
        filterStudyList(_.cloneDeep(salesCatalystStudies), SALES_CATALYST_FEATUREID),
        preferences[PREFERENCE_STUDY]);
    }
    const { salesCatalyst } = getState();
    const cloneSalesCatalystData = _.cloneDeep(salesCatalyst);
    Promise.all([
      dispatch(setPreferenceFlag('salesCatalyst', false)),
      dispatch(resetSalesCatalystScreen('', createSSDataOptions(SALES_CATALYST_RESET_ALL))),
      dispatch(setSalesCatalystPreferenceStudy(getStudyObj)),
    ]).then(() => {
      // Logic To Update SalesCatalyst Reducer
      _.forEach(_.keys(preferences), key => {
        if (key === PREFERENCE_SALES_CATALYST_BASE) {
          preferences[key] = preferences[key][0];
        } else if (key === PREFERENCE_SALES_CATALYST_SELECTED_SE_LIST) {
          preferences[key] = {
            templateId: preferences[key].value,
            templateName: preferences[key].label,
          };
        }
        // Storing the prefernces data to session object
        cloneSalesCatalystData.scSessionConfiguration = { _sc: sessionConfigurationObject };
        const mappingObject = _.find(SALES_CATALYST_PREFERENCE_KEY_MAPPING, { LABEL: key });
        if (mappingObject && !_.isEmpty(mappingObject)) {
          const { MAINCATEGORY, CATEGORY } = mappingObject;
          if (MAINCATEGORY !== '') {
            if (typeof MAINCATEGORY === 'object') {
              const _mainCategory = MAINCATEGORY[0];
              const _subCategory = MAINCATEGORY[1];
              cloneSalesCatalystData[_mainCategory][_subCategory][CATEGORY] = preferences[key];
            } else {
              cloneSalesCatalystData[MAINCATEGORY][CATEGORY] = preferences[key];
            }
          } else {
            cloneSalesCatalystData[CATEGORY] = preferences[key];
          }
        }
      });
      Promise.resolve(dispatch(setSalesCatalystPreferenceData(cloneSalesCatalystData)))
        .then(() => {
          dispatch(setPreferenceFlag('salesCatalyst', true));
        });
    });
  }
};

const formatIndexRangeFilter = rangeFilter => {
  let filterValue;
  switch (rangeFilter.selectedOption) {
    case 'Highest':
      filterValue = '>';
      break;
    case 'Greater Than':
      filterValue = '>';
      break;
    case 'Less Than':
      filterValue = '<';
      break;
    case 'Equals':
      filterValue = '=';
      break;
    case 'Range':
      filterValue = '//';
      break;
    default:
      filterValue = '>';
  }
  return `${filterValue + rangeFilter.value.join()}`;
};

export const getFilterConfig = (state, report = '', filterConfigFlag = '') => {
  let filterConfig = {};
  let pct = DEFAULT_REACH;
  let sample = DEFAULT_SAMPLE;
  let index = DEFAULT_INDEX;
  if (!_.isEmpty(state().salesCatalyst.scSessionConfiguration)) {
    if (_.indexOf([SC_COMPETITORS_COMPARISON], report) !== -1 && filterConfigFlag !== '') {
      /* setting sample, pct for competitor strengths and weakness based on preferences */
      const preferenceData = state().salesCatalyst.scSessionConfiguration;
      if (filterConfigFlag === STRENGTHS_FILTER_CONFIG) {
        pct = preferenceData[PREFERENCE_SALES_CATALYST][PREFERENCE_SALES_CATALYST_STRENGTH_REACH];
        sample =
      preferenceData[PREFERENCE_SALES_CATALYST][PREFERENCE_SALES_CATALYST_STRENGTH_SAMPLE_MINIMUM];
        index = preferenceData[PREFERENCE_SALES_CATALYST][PREFERENCE_SALES_CATALYST_STRENGTH_INDEX];
      } else if (filterConfigFlag === WEAKNESS_FILTER_CONFIG) {
        pct = preferenceData[PREFERENCE_SALES_CATALYST][PREFERENCE_SALES_CATALYST_WEAKNESSES_REACH];
        sample =
      preferenceData[PREFERENCE_SALES_CATALYST][PREFERENCE_SALES_CATALYST_WEAKNESS_SAMPLE_MINIMUM];
        index = preferenceData[PREFERENCE_SALES_CATALYST][PREFERENCE_SALES_CATALYST_WEAKNESS_INDEX];
      }
      filterConfig = {
        sample: `>${sample}`,
        pct: `>${pct}`,
        index: formatIndexRangeFilter(index),
      };
    } else {
    /* setting sample, pct from preferences */
      pct = state().salesCatalyst
        .scSessionConfiguration[PREFERENCE_SALES_CATALYST][PREFERENCE_SALES_CATALYST_REACH];
      sample = state().salesCatalyst
        .scSessionConfiguration[PREFERENCE_SALES_CATALYST][PREFERENCE_SALES_CATALYST_SAMPLE];
      index = state().salesCatalyst
        .scSessionConfiguration[PREFERENCE_SALES_CATALYST][PREFERENCE_SALES_CATALYST_INDEX];
    }
    filterConfig = {
      sample: `>${sample}`,
      pct: `>${pct}`,
      index: formatIndexRangeFilter(index),
    };
  }
  return filterConfig;
};

export const getBrandAndMediaFiltersFromPreferences = preferences => {
  let brandFilters = [];
  let mediaFilters = [];
  if (preferences && preferences.userPreferences && preferences.userPreferences[PREFERENCE_SALES_CATALYST]) {
    brandFilters = _.cloneDeep(
      preferences.userPreferences[PREFERENCE_SALES_CATALYST][PREFERENCE_SALES_CATALYST_BRAND_FILTER_LIST]);
    mediaFilters = _.cloneDeep(
      preferences.userPreferences[PREFERENCE_SALES_CATALYST][PREFERENCE_SALES_CATALYST_MEDIA_FILTER_LIST]);
  }
  return { brandFilters, mediaFilters };
};

